import { render, staticRenderFns } from "./CommunityListDialog.vue?vue&type=template&id=64cc5423&scoped=true"
import script from "./CommunityListDialog.vue?vue&type=script&lang=js"
export * from "./CommunityListDialog.vue?vue&type=script&lang=js"
import style0 from "./CommunityListDialog.vue?vue&type=style&index=0&id=64cc5423&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cc5423",
  null
  
)

export default component.exports